import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.71012 6.50469L14.4456 1H13.3233L9.21165 5.77953L5.92752 1H2.13965L7.10585 8.22759L2.13965 14H3.26191L7.60412 8.95265L11.0723 14H14.8601L9.70981 6.50469H9.71012ZM8.17307 8.29117L7.66983 7.5715L3.66623 1.8448H5.38995L8.62076 6.4665L9.1239 7.18617L13.3238 13.1936H11.6003L8.17307 8.29148V8.29117Z",
		fill: "currentColor"
	})
});
export default SvgTwitter;
